<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 20L18 20M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5"
      stroke="url(#paint0_linear_1481_35612)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1481_35612"
        x1="-2.5"
        y1="12"
        x2="27"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'DownloadIcon'
}
</script>
